<!-- @format -->
<script lang="ts">
    import { getStoresContext } from "~/stores";
    import type { StoresKey } from "~/stores";
    import { parseExceptionalOpeningHoursItem, parseDateISO, formatDate } from "~/util/date-n-time";

    export let request_store_key: StoresKey;
    const { store, T, locale } = getStoresContext(request_store_key);

    let exceptional_openinghours_formatted:{ date: string, hours: string, fromHour: number, fromMinute: number, open: boolean, reason: string, toHour: number, toMinute: number}[];
    $: t = $T;

    $: if($store) {
        exceptional_openinghours_formatted = ($store.exceptionalOpeningHours || [])
        .slice(0, 3)
        .map((item) => {
            return {
                ...item,
                date: formatDate(parseDateISO(item.date), $locale, { day: 'numeric', month: 'numeric' }),
                hours:  parseExceptionalOpeningHoursItem($locale, item)
            };
        });
    }
</script>

{#each $store.openingHours.split(',') as time}
    <p class="mt-3 mt-lg-0 mx-3 mx-lg-0 mb-2">{time}</p>
{/each}
{#if exceptional_openinghours_formatted.length > 0}
    <div class="mb-3 mx-3">
        <p class="exception-title">{t`opening-hours-exceptional`}</p>
        {#each exceptional_openinghours_formatted as item}
            <div class="exception">
                <span class="fw-bold">{item.date}: </span>
                <span>{@html item.open ? item.hours : t`opening-status-closed`}</span>
                <span>{item.reason}</span>
            </div>
        {/each}
    </div>
{/if}

<style lang="scss">
    .exception-title {
        font-size: 1.2rem;
        margin-top: 2rem;
        @media screen and (max-width: 991px) {
            font-size: 1rem;
        }
    }
    .exception span {
        display: inline-block;
        padding-right: 4px;
    }
</style>